module.exports = __webpack_public_path__ + "static/media/hp_15.3d8227a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_15.jpg
// module id = 5826
// module chunks = 0